<script>
import TrainingRequestPage from "@/views/Training/TrainingRequest/TrainingRequestPage.vue";

export default {
    components: {TrainingRequestPage}
}
</script>

<template>
    <training-request-page intranet/>
</template>

